import _ from 'lodash';

(() => {
	window.T1 = window.T1 || {
		settings: {
			ssoServiceUrl: '//ssomsa.toyota-europe.com',
		}
	};
})();

export const routes = {
    SERVICE: {
        SSO: T1.settings.ssoServiceUrl,
		CAMPAIGNS_APP: _.get(window, 'APP_SETTINGS.rootPath', 'https://campaigns-lexus-europe.com/')
    },
    ENDPOINTS: {
		CAMPAIGNS : {
			GET_USER_DATA: '/vip-hub/data/get-user-data',
			SAVE_USER_DATA: '/vip-hub/data/save-user-preferences',
			DELETE_WEBGL_CONFIGURATION: '/vip-hub/data/delete-webgl-configuration',
			GET_INSTAGRAM_POSTS:'/instagram/get-media',
			EXTRACT_COLOR_PALETTE:'/ai-experience/artwork/colour-extraction',
			GENERATE_ARTWORK:'/ai-experience/artwork/create',
			GET_ARTWORK_STATUS:'/ai-experience/artwork/status',
			GET_IMAGE_BUFFER:'/ai-experience/artwork/download'
		},
		SSO: {
			VALIDATE_TOKEN: '/isTokenValid',
		}
    }
}